import apiClient from './Api';
const PREFIX = '/usersettings';

const getPresavedUserSelections = () => {
  return apiClient({
    url: `${PREFIX}/get`,
    method: 'GET'
  });
};

const addPresavedUserSelection = postData => {
  return apiClient({
    url: `${PREFIX}/save`,
    method: 'POST',
    data: postData
  });
};

const removePresavedUserSelection = postData => {
  return apiClient({
    url: `${PREFIX}/delete`,
    method: 'POST',
    data: postData
  });
};

const UserSettingsService = {
  removePresavedUserSelection,
  addPresavedUserSelection,
  getPresavedUserSelections
};
export default UserSettingsService;
